import React from 'react'

import { useModal } from '@context/ModalsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { ClientNciPriorityDto } from '@model/ClientNciPriorityDto'
import { CreateClientDocument } from '@model/CreateClientDocuments'
import { ClientCreateNciFinalHistory } from '@model/CreateNciHistory'
import { UploadDocumentCategoryEnum } from '@model/UploadDocumentCategoryEnum'

import { AlreadyUploadedModal } from '@shared/modals/AlreadyUploaded.modal'

import { DocumentInfoNCIPageStep1Form } from './DocumentInfoNCIPageStep1Form'

interface OuterProps {
  accountNciAvailablePriorities: ClientNciPriorityDto

  onSkip(): void

  onSkipDocuments(): void

  handleSubmitReason(reason: string): void

  handleChoosePreviousDoc(doc: ClientNciPriorityDto, count: number): void

  handleSubmit(): void
}

export const DocumentInfoNCIPageStep1Page: React.FC<OuterProps> = (props) => {
  const apiClient = useApiClient(ClientApiClient)

  const alreadyUploadedModal = useModal(AlreadyUploadedModal)

  const handleSubmit = async (
    values: ClientCreateNciFinalHistory,
    documents: CreateClientDocument[]
  ) => {
    await apiClient.accountAcceptFinalNciHistory(values)
    try {
      await apiClient.uploadDocuments({ documents })
      props.handleSubmit()
    } catch (error: unknown) {
      alreadyUploadedModal.open({ message: (error as any).response?.response?.data?.code })
    }
  }

  return (
    <DocumentInfoNCIPageStep1Form
      {...props}
      handleSubmit={handleSubmit}
      documentCategory={UploadDocumentCategoryEnum.Personal}
    />
  )
}
